// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://cwzpukwrlihylylmitqq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImN3enB1a3dybGloeWx5bG1pdHFxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQyNjY3ODksImV4cCI6MjA1OTg0Mjc4OX0.QsaDEowJljGeh3Cn1XmPv6JCpYbrcSTzfhLXYeAsQJA";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});